"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifFound = ifFound;
const not_found_error_1 = require("./not-found-error");
async function ifFound(loading) {
    try {
        return await loading;
    }
    catch (error) {
        if (error instanceof not_found_error_1.NotFoundError)
            return undefined;
        throw error;
    }
}
